
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField, Paper } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout'
import { SearchTextField } from '../../components/SearchTextField';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerDistritoJudicial } from '../../connections/catalogos/DistritoJudicialConnection';
import { ActualizarAutoridadExhortoLibrado, AgregarAutoridadExhortoLibrado, AutoridadesExhortoLibrado } from '../../connections/catalogos/AutoridadExhortoLibradoConnection';

import { DistritoJudicialProps } from '../../interfaces/catalogos/DistritoJudicialInterface';
import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadExhortoLibradoProps } from '../../interfaces/catalogos/AutoridadExhortoLibradoInterface';

export const AutoridadExhortoLibradoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [idAutoridadExhortoLibrado, setIdAutoridadExhortoLibrado] = useState( 0 );
    const [AutoridadExhortoLibrado, setAutoridadExhortoLibrado] = useState<AutoridadExhortoLibradoProps[]>( [] );

    const [distritoJudicial, setDistritoJudicial] = useState( 0 );
    const [distritoJudicialArray, setDistritoJudicialArray] = useState<DistritoJudicialProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [descripcion, setDescripcion] = useState( '' );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroDistritoJudicial, setFiltroDistritoJudicial] = useState( '' );
    const [filtroMateria, setFiltroMateria] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( AutoridadExhortoLibrado, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fdj = filtroDistritoJudicial.toLowerCase();
        const fm = filtroMateria.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroDistritoJudicial === '' || ( item.distritoJudicial?.descripcion?.toLowerCase().includes( fdj ) ?? false ) ) &&
            ( filtroMateria === '' || ( item.materia?.descripcion?.toLowerCase().includes( fm ) ?? false ) )
        );
    });

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const AutoridadExhortoLibradoselected = AutoridadExhortoLibrado.find((elem) => elem.idAutoridadExhortoLibrado === id);

        if (AutoridadExhortoLibradoselected) {

            await ActualizarAutoridadExhortoLibrado({ ...AutoridadExhortoLibradoselected, activo: checked }).then(resp => {

                if (resp.idAutoridadExhortoLibrado) {

                    var newArray = AutoridadExhortoLibrado.map((elem) => {

                        if (elem.idAutoridadExhortoLibrado === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setAutoridadExhortoLibrado(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idAutoridadExhortoLibrado !== 0) {

            const AutoridadExhortoLibradoSelected = AutoridadExhortoLibrado.find((elem) => elem.idAutoridadExhortoLibrado === idAutoridadExhortoLibrado);

            if ( AutoridadExhortoLibradoSelected ) {

                setLoading( true );

                await ActualizarAutoridadExhortoLibrado({ ...AutoridadExhortoLibradoSelected, descripcion, idDistritoJudicial: distritoJudicial, idMateria: materia }).then(resp => {

                    if ( resp.idAutoridadExhortoLibrado ) {

                        setTimeout(() => {

                            var newArray = AutoridadExhortoLibrado.map((elem) => {

                                if (elem.idAutoridadExhortoLibrado === idAutoridadExhortoLibrado) {
                                    elem.descripcion = descripcion;
                                    elem.idDistritoJudicial = distritoJudicial;
                                    elem.distritoJudicial = resp.distritoJudicial
                                    elem.idMateria = materia;
                                    elem.materia = resp.materia
                                }

                                return elem;
                            });

                            setAutoridadExhortoLibrado(newArray);
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const distritoJudicialAdd: AutoridadExhortoLibradoProps = {
                idAutoridadExhortoLibrado: 0,
                descripcion,
                idDistritoJudicial: distritoJudicial,
                idMateria: materia,
                activo: true,
            };

            setLoading( true );

            await AgregarAutoridadExhortoLibrado(distritoJudicialAdd).then(resp => {

                if (resp.idAutoridadExhortoLibrado) {

                    setTimeout(() => {

                        setAutoridadExhortoLibrado([...AutoridadExhortoLibrado, resp]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó la autoridad del exhorto librado correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setAutoridadExhortoLibrado( [] );

            await AutoridadesExhortoLibrado().then(resp => {

                setTimeout(() => {

                    setAutoridadExhortoLibrado(resp);
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setDistritoJudicialArray( [] );

            await ObtenerDistritoJudicial().then(resp => {

                setTimeout(() => {

                    setDistritoJudicialArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setMateriaArray( [] );

            await ObtenerMateria().then(resp => {

                setTimeout(() => {

                    setMateriaArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Autoridad de exhorto librado' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={() => {

                            setIdAutoridadExhortoLibrado( 0 );
                            setMateria( 0 );
                            setDistritoJudicial( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroDistritoJudicial }
                        label='Buscar por distrito judicial'
                        onChange={ ( value ) => {
                            setFiltroDistritoJudicial( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroMateria }
                        label='Buscar por materia'
                        onChange={ ( value ) => {
                            setFiltroMateria( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', }}> Descripcion </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}> Distrito Judicial </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}> Materia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idAutoridadExhortoLibrado, descripcion, activo, idDistritoJudicial, distritoJudicial, idMateria, materia,  }) => (

                                    <TableRow key={ idAutoridadExhortoLibrado } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idAutoridadExhortoLibrado}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {distritoJudicial?.descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {materia?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked(e.target.checked, idAutoridadExhortoLibrado) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={() => {

                                                    setIdAutoridadExhortoLibrado( idAutoridadExhortoLibrado );
                                                    setMateria( idMateria? idMateria: 0 );
                                                    setDistritoJudicial( idDistritoJudicial? idDistritoJudicial: 0);
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Distrito Judicial</InputLabel>

                                <Select
                                    label='Distrito Judicial'
                                    value={ distritoJudicial }
                                    onChange={ (e) => setDistritoJudicial( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        distritoJudicialArray.map( (elem) => (
                                            <MenuItem key={ elem.idDistritoJudicial } value={ elem.idDistritoJudicial }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Materia</InputLabel>

                                <Select
                                    label='Materia'
                                    value={ materia }
                                    onChange={ (e) => setMateria( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray.map( (elem) => (
                                            <MenuItem key={ elem.idMateria } value={ elem.idMateria }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion(e.target.value) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={() => { setOpenDialog( false ); }}> Cancelar </Button>
                    <Button loading={ loading } disabled={ materia === 0 || distritoJudicial === 0 } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}